import { States } from './states';

const allValidations = {
  states: States,
};

export default allValidations;
